import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Mic2 } from 'lucide-react';
import { toast } from 'sonner';

export const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            navigate('/dashboard');
        } catch (err) {
            toast.error(err.response?.data?.detail || 'Credenciais inválidas');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-stone-950 flex items-center justify-center p-4">
            <div className="w-full max-w-sm">
                {/* Logo */}
                <div className="text-center mb-8">
                    <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-700 to-amber-900 flex items-center justify-center mx-auto mb-4 shadow-xl">
                        <Mic2 className="w-8 h-8 text-amber-200" />
                    </div>
                    <h1 className="text-2xl font-bold text-stone-100">Tayane Larini</h1>
                    <p className="text-stone-500 text-sm mt-1">Hub Oficial · CRM</p>
                </div>

                {/* Form */}
                <div className="bg-stone-900 rounded-2xl border border-stone-800 p-6 shadow-2xl">
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-1.5">
                            <Label className="text-stone-300 text-sm">E-mail</Label>
                            <Input
                                type="email" value={email} onChange={e => setEmail(e.target.value)}
                                placeholder="admin@tayanelarini.com.br" required
                                className="bg-stone-800 border-stone-700 text-stone-100 placeholder:text-stone-600"
                            />
                        </div>
                        <div className="space-y-1.5">
                            <Label className="text-stone-300 text-sm">Senha</Label>
                            <Input
                                type="password" value={password} onChange={e => setPassword(e.target.value)}
                                placeholder="••••••••" required
                                className="bg-stone-800 border-stone-700 text-stone-100 placeholder:text-stone-600"
                            />
                        </div>
                        <Button type="submit" disabled={loading} className="w-full bg-amber-700 hover:bg-amber-600 text-white font-semibold mt-2">
                            {loading ? 'Entrando...' : 'Entrar'}
                        </Button>
                    </form>
                </div>

                <p className="text-center text-xs text-stone-600 mt-6">
                    Cantora · Autora · Mentora de Mulheres
                </p>
            </div>
        </div>
    );
};

export default Login;
